import { Tab, TabGroup, TabList } from '@headlessui/react'
import { NewsletterSplitTestViewApiInterface } from 'modules/newsletters/single/types/newsletter-view-interface'
import Router, { useRouter } from 'next/router'
import React, { useEffect } from 'react'
import { useLocoTranslation } from 'shared/hooks/use-loco-translation'
import { twMerge } from 'tailwind-merge'
import { CheckCircleIcon } from '@systemeio/ui/icons'

interface VariantsTabsProps {
  splitTestData: NewsletterSplitTestViewApiInterface['mailingSplitTest']
  variantAHasError: boolean
  variantBHasError: boolean
}

export function VariantsTabs({
  splitTestData,
  variantAHasError,
  variantBHasError,
}: VariantsTabsProps) {
  const { t } = useLocoTranslation()
  const { query, replace } = useRouter()

  const selectedVariant = query.variant ? Number(query.variant) : undefined

  useEffect(() => {
    if (!selectedVariant) {
      Router.replace(
        { query: { ...query, variant: splitTestData.mailingVariantA.id } },
        undefined,
        { scroll: false },
      )
    }
  }, [query, selectedVariant, splitTestData.mailingVariantA.id])

  const getTab = (id: number, title: string, hasErrors: boolean) => {
    const isWinner = splitTestData.mailingWinnerSourceId === id
    return (
      <Tab
        className={twMerge(
          selectedVariant === id && 'text-brand-primary bg-text-secondary/10',
          'flex flex-1 items-center justify-center gap-1.5 rounded-md px-3 py-1 text-base outline-hidden lg:flex-auto',
          hasErrors && 'text-danger',
        )}
        onClick={() => replace({ query: { ...query, variant: id } }, undefined, { scroll: false })}
      >
        {isWinner && (
          <CheckCircleIcon className={`fill-green h-[16px] w-[16px] sm:h-[20px] sm:w-[20px]`} />
        )}
        {title}
      </Tab>
    )
  }
  return (
    <TabGroup>
      <TabList className="bg-background-secondary flex w-full gap-1 rounded-t-md p-1 lg:w-fit">
        {getTab(
          splitTestData.mailingVariantA.id,
          t('dashboard.newsletter_editor.split_test.variant_a'),
          variantAHasError,
        )}
        {getTab(
          splitTestData.mailingVariantB.id,
          t('dashboard.newsletter_editor.split_test.variant_b'),
          variantBHasError,
        )}
      </TabList>
    </TabGroup>
  )
}
